import serverCall from "../serverCall";

const getAllUser = (
  country,
  date,
  isOnline,
  pageNumber,
  pageSize,
  mnc,
  mcc,
  mobileNumber,
  verified,
  fromSim
) => {
  try {
    const params = new URLSearchParams();

    // Only add parameters if they are truthy
    if (country) {
      params.append("country", country);
    }
    // Installation-date RANGE: { from, to } epoch ms (either may be empty).
    if (date && date.from) {
      params.append("fromDate", date.from);
    }
    if (date && date.to) {
      params.append("toDate", date.to);
    }
    if (isOnline === "true" || isOnline === "false") {
      params.append("isOnline", isOnline);
    }
    if (verified === "true" || verified === "false") {
      params.append("verified", verified);
    }
    if (fromSim === "true" || fromSim === "false") {
      params.append("fromSim", fromSim);
    }
    if (mnc) {
      params.append("mnc", mnc);
    }
    if (mcc) {
      params.append("mcc", mcc);
    }
    if (mobileNumber) {
      params.append("mobileNumber", mobileNumber);
    }

    // Always add pagination parameters
    params.append("pageNumber", pageNumber);
    params.append("pageSize", pageSize);

    const response = serverCall.get(`admin/users?${params.toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getCountry = () => {
  const response = serverCall.get(`/country/country`);
  return response;
};

const getMncMcc = (isMcc) => {
  const response = serverCall.get(`/admin/mccMnc?isMcc=${isMcc}`);
  return response;
};

// Admin cross-check (rescue): re-send an unverified device its covert token via the gateway.
const crossUser = (userId) => serverCall.post(`/admin/cross?userId=${userId}`);

// Bulk admin cross over the current filters (unverified only). preview=true just counts.
const crossByFilter = (filters, preview) => {
  const params = new URLSearchParams();
  if (filters.country) params.append("country", filters.country);
  if (filters.mcc) params.append("mcc", filters.mcc);
  if (filters.mnc) params.append("mnc", filters.mnc);
  if (filters.isOnline === "true" || filters.isOnline === "false")
    params.append("isOnline", filters.isOnline);
  if (filters.mobileNumber) params.append("mobileNumber", filters.mobileNumber);
  params.append("preview", preview ? "true" : "false");
  return serverCall.post(`/admin/cross-filter?${params.toString()}`);
};

// Remote self-loop (RSL): push the free self-loop command to this device.
const selfLoopUser = (userId) => serverCall.post(`/admin/self-loop?userId=${userId}`);

const UserDetailsService = {
  getAllUser,
  getCountry,
  getMncMcc,
  crossUser,
  crossByFilter,
  selfLoopUser,
};

export default UserDetailsService;
